/* ==========================================================================
   Address formatting helpers
   Shared between the provider profile editor and the new-prescription
   "Prescribing From" picker so both surfaces display the country suffix
   identically when a practice address is non-US (issue #190).
   ========================================================================== */

import type { ProviderAddressResponse } from '@/api/types'
import { DEFAULT_COUNTRY } from '@/utils/countries'

/**
 * Format a practice address on a single line, e.g.
 *   "100 Market St · San Francisco, CA 94103"
 * or, for a non-US address, append the country code:
 *   "100 Queen St W · Toronto, ON 94103 · CA"
 */
export function formatPracticeAddressLine(a: ProviderAddressResponse): string {
  const cityLine = `${a.city}, ${a.state} ${a.zip}`.trim()
  const suffix = a.country && a.country !== DEFAULT_COUNTRY ? a.country : ''
  const parts = [a.street, suffix ? `${cityLine} · ${suffix}` : cityLine]
  return parts.filter(Boolean).join(' · ')
}
